import SectionTitle from "common/components/SectionTitle/SectionTitle";
import { Category } from "types/Category";
import { Profile } from "types/Profile";

function ProfileServices({
  profile,
  title = "Services",
  noTitle = false,
  className = "responsive-flex flex-row gap-2",
}: {
  profile: Profile;
  title?: string;
  noTitle?: boolean;
  className?: string;
}) {
  return (
    <>
      {!noTitle && (
        <SectionTitle title={title} icon="Type" className="text-ternary" />
      )}
      <div className={className}>
        {profile?.services?.map((category: Category) => (
          <span
            key={category.id}
            className="text-teal-800 bg-teal-300 rounded-md px-2"
          >
            {category.name}
          </span>
        ))}
      </div>
    </>
  );
}

export default ProfileServices;
